import { render, staticRenderFns } from "./Consultation.vue?vue&type=template&id=0a29fe68&"
import script from "./Consultation.vue?vue&type=script&lang=ts&"
export * from "./Consultation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports